/*
 * Copyright 2026 Bytefinger Technology (HK) Co., Limited
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { DebounceTime, type HostedObserverConfig } from '@adp-studio/autosave';

import { type BotSkillStore } from '@/store/bot-skill';
import { ItemTypeExtra } from '@/save-manager/types';

interface AgentStoreFeaturesState {
  gemEnabled: boolean;
  scheduleEnabled: boolean;
}

type RegisterAgentStoreFeatures = HostedObserverConfig<
  BotSkillStore,
  ItemTypeExtra,
  AgentStoreFeaturesState
>;

export const agentStoreFeaturesConfig: RegisterAgentStoreFeatures = {
  key: ItemTypeExtra.AgentStoreFeatures,
  selector: {
    deps: [state => state.gemEnabled, state => state.scheduleEnabled],
    transformer: (gemEnabled, scheduleEnabled) => ({
      gemEnabled,
      scheduleEnabled,
    }),
  },
  debounce: DebounceTime.Immediate,
  middleware: {
    onBeforeSave: ({ gemEnabled, scheduleEnabled }) => ({
      gem_enabled: gemEnabled,
      schedule_enabled: scheduleEnabled,
    }),
  },
};
